<template lang="html">
  <v-app>
    <v-main id="pagetop">
      <!-- <AppHeader /> -->
      <router-view />
      <AppFooter />
      <TopButton />
    </v-main>
  </v-app>
</template>

<script>
  // import AppHeader from "./components/AppHeader.vue";
  import AppFooter from "./components/AppFooter.vue";
  import TopButton from "./components/TopButton.vue";

  export default {
    name: "App",
    components: {
      // AppHeader,
      AppFooter,
      TopButton,
    },
  };
</script>

<style>
  h1 {
    text-align: center;
    font-family: heisei-mincho-std, serif;
    font-weight: 400;
    font-style: normal;
    margin: 30px auto;
    font-size: 3em;
    color: rgb(var(--v-theme-primary));
  }
  h2 {
    font-family: heisei-mincho-std,  sans-serif;
    letter-spacing: 0.5em;
  }
</style>
